var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-need_help';
                    var viewUrl = 'gfx/sprite.svg#view-icon-need_help';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };